import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

window.introJs = require('intro.js')
window.Swipe = require('swipejs')

window.Popper = require('@popperjs/core')
window.jQuery = require('jquery')
window.$ = window.jQuery

require('bootstrap')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
